module.exports = __webpack_public_path__ + "static/media/replate-rgb.e3d7c5fa.svg";